export enum WorkflowState {
  NOT_SET = "NOT_SET",
  COMPLETE = "COMPLETE",
  INCOMPLETE = "INCOMPLETE"
}
